<template>
  <GestionArchivosSolicitudes />
</template>
<script>
import GestionArchivosSolicitudes from "./components/GestionSolicitudesRechazadas";
export default {
  name: "ArchivosSolicitudes",
  components: { GestionArchivosSolicitudes }
};
</script>
